export const programsPageLimit = 12;
export const programSubscriptionBannerAfterSubCategoryIndex = 20;

export const getProgramsQuery = (page: number) => ({
  page,
  limit: programsPageLimit,
});
